import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stripHtml' })
export class StripHtmlPipe implements PipeTransform {
  transform(value: any): string {
    if (value == null) return '';
    try {
      const div = document.createElement('div');
      div.innerHTML = String(value);
      // Get textContent (removes all tags) and collapse excessive whitespace
      const text = (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
      return text;
    } catch {
      return String(value);
    }
  }
}
